export default {
  default: [
    {
      path: "/mijn-gegevens",
      name: "advisor.details",
      component: () => import("@/modules/advisors/views/AdvisorDetailsView.vue")
    },
    {
      path: "/mijn-gegevens/wijzigen",
      name: "advisor.details.edit",
      component: () => import("@/modules/advisors/views/AdvisorFormView.vue")
    }
  ]
};
